import { useState } from 'react';

import { styled } from '@mui/material';

import { zIndex } from '../styles';

export const COOKIE_SEEN_KEY = 'COOKIE_SEEN_KEY';

const CookieBannerStyled = styled('div')`
  position: fixed;
  bottom: 40px;
  left: 10%;
  right: 10%;
  width: 80%;
  padding: 5px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eee;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  z-index: ${zIndex.modal};

  .close {
    font-size: 24px;
    border: none;
    color: rgb(145, 0, 0);
    border-radius: 2px;
    cursor: pointer;
  }
`;

export const CookieBanner = () => {
  const [showCookieBanner, setShowCookieBanner] = useState<string>(
    localStorage.getItem(COOKIE_SEEN_KEY) || '',
  );

  const onClick = () => {
    localStorage.setItem(COOKIE_SEEN_KEY, 'shown');
    setShowCookieBanner('shown');
  };

  if (showCookieBanner === 'shown') {
    return null;
  }

  return (
    <CookieBannerStyled>
      <p>
        By navigating on this site you agree that we use only minimal cookies required for this site
        to function. We do not monetize your data.
      </p>
      <button onClick={onClick} className="close" aria-label="Close cookie banner">
        &times;
      </button>
    </CookieBannerStyled>
  );
};
